import Joi from 'joi';

const PHONE_REGEX = /^\+[\(\)\.\-\s\d]{6,29}$/;
const PHONE_MESSAGE = 'Please enter the phone number starting with a "+" sign, followed by digits, spaces, parentheses , dots, and hyphens.';

const customerSchema = Joi.object({
  name: Joi.string()
    .required()
    .trim()
    .min(2)
    .max(100)
    .label('Name'),

  phone: Joi.string()
    .required()
    .trim()
    .pattern(PHONE_REGEX)
    .messages({
      'string.pattern.base': PHONE_MESSAGE
    })
  .label('Phone'),

  email: Joi.string()
    .trim()
    .optional()
    .pattern(/^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|)$/)
    .allow('')
    .messages({
      'string.pattern.base': 'Invalid email format'
    })
    .label('Email'),

  comment: Joi.string()
    .trim()
    .optional()
    .allow('')
    .max(255)
    .label('Comment'),
  
  whatsapp: Joi.string()
    .optional()
    .trim()
    .allow('')
    .pattern(PHONE_REGEX)
    .messages({
      'string.pattern.base': PHONE_MESSAGE
    })
  .label('WhatsApp'),

});


const validateCustomer = (data) => {
  return customerSchema.validate(data);
};

export { validateCustomer };